export const palette = {
  primary: {
    main: '#1891F6',
    text: '#000',
  },
  secondary: {
    main: '#BAC0D0',
  },
  appBar: {
    main: {
      bg: '#1C3F94',
      fg: '#FFF',
    },
  },
  btnPrimary: {
    main: {
      // bg: 'rgb(2, 123, 253)',
      bg: 'linear-gradient(99.7deg, #15205E -19.43%, #0076F4 80.93%)',
      fg: '#FFF',
    },
  },
  btnSecondary: {
    main: {
      bg: '#FFF',
      fg: '#333',
    },
  },
  btnDelete: {
    bg: '#CA1902',
    fg: '#FFF',
  },
  btnDisabled: {
    bg: '#CCC',
    fg: '#FFF',
  },
  tabs: {
    bg: '#EEE',
    indicator: '#1891F6',
  },
  switch: {
    main: 'rgb(2, 123, 253)',
    simulationUI: '#6F58CA',
  },
};
